<template>
    <div style="background:white;height:100%">         
        <div style=" display:flex; width:100%; background:#fff;line-height:30px;height:40px;  border-bottom:2px solid #389">
            <div style="min-width:1100px;display:flex;padding-top:3px">
                <div style="font-size:12px;margin-right:5px;margin-left:12px;font-weight:600">账期月份</div>
                <el-date-picker v-model="v_dttm" :picker-options="pickerOptions"  value-format="yyyy-MM" type="month"  size="small"  placeholder="请选择月份" style="width:130px;font-size:14px"> 
         
                </el-date-picker>
                <el-button  type="danger" @click="qryTabData" icon="iconfont icon-chakan-copy" size="mini" style="width:70px; height:32px;margin-left:10px">查询</el-button>
            </div>
        </div> 
        <div style="display:flex;justify-content:space-between">
            <div style="width:49%;margin-top:1px" >
                <div class="one-div"> <span class="oneRow"> 应收明细 </span> 
                    <el-checkbox @change="getArList" true-label="Y" false-label="N" v-model="v_receive" style=" margin-left:15px"><span style="font-size:12px;color:#389">包含已收完</span>  </el-checkbox>
                </div>
                <el-table  :data="tabData" 
                    border                            
                    disabled-hover
                    class="custom-table-border"
                    style="overflow:auto;margin-top:-8px;"
                    size="small"
                    header-cell-class-name="clearPadding"
                    show-summary
                    :summary-method="getSummary"
                    :height="tabHeight" 
                    :row-key="getRowKey"  
                    :header-cell-style="{ 'color':'#389','text-align':'center','height':'16px'}"
                    ref="refar" 
                    :cell-style="{padding:'2px','font-size':'12px',color:'#001','font-weight':'600'}"
                    highlight-current-row>
                    <el-table-column label="序号" type="index" width="55" fixed align="center">
                        <el-table-column label="序号" type="index" width="55" fixed align="center">
                            <template slot="header"  >
                                <el-link   @click="rowShow" style="font-size:12px;color:#404eff"> 
                                    <el-tooltip content=" 清除条件" effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column  v-for="(item,index ) in tabArr.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.key!=='RN'&&item.sortable=='N'"
                        :min-width="item.width">
                        <el-table-column  resizable :prop="item.key" :label="item.title" :align="item.align"  show-overflow-tooltip :min-width="item.width">
                            <template slot="header" slot-scope="scope">
                                {{scope.row}}
                                <el-input type="number" placeholder="数字框"  @keyup.enter.native="getArList" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                                <el-input v-else @keyup.enter.native="getArList"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                            </template>
                            <template slot-scope="scope" >
                                <el-checkbox v-if="item.edcss=='checkbox'"  true-label="Y"  false-label="N" v-model="scope.row[item.key]" ></el-checkbox>
                                <el-progress v-else-if="item.key=='PCT'" :text-inside="true" :stroke-width="22" :percentage="Number(scope.row['PCT'])"  style="color:red"></el-progress> 
                                <span v-else v-text="scope.row[item.key]"></span>
                            </template>
                        </el-table-column>
                    </el-table-column>                   
                </el-table>  
                <div class="one-div" style="margin-top:2px"> <span class="oneRow"> 当前账户资金余额 </span> </div>
                <el-table  :data="cashArr" 
                    border                            
                    disabled-hover
                    class="custom-table-border"
                    style="overflow:auto;margin-top:-8px;"
                    size="small"
                    header-cell-class-name="clearPadding"  
                    show-summary
                    :summary-method="getMinSum"
                    :height="230" 
                    :row-key="getRowKey"  
                    :header-cell-style="{ 'color':'#f00','text-align':'center','height':'16px'}"
                    ref="refmin" 
                    :cell-style="{padding:'4px','font-size':'12px', 'font-weight':'600',color:'black' }"
                    v-loading="t_loading"
                    element-loading-text="加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    highlight-current-row>
                    <el-table-column label="序号" type="index" width="55" fixed align="center"></el-table-column>
                    <el-table-column  v-for="(item,index ) in minCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.key!=='RN'&&item.sortable=='N'"
                        :min-width="item.width">
                            <template slot-scope="scope" >
                                <span  v-text="scope.row[item.key]"></span>
                            </template>
                    </el-table-column>                   
                </el-table>  
            </div>
            <div style="width:50%;margin-top:1px" >
                <div class="one-div"> <span class="oneRow"> 应付明细 </span> 
                    <el-checkbox @change="getApList" true-label="Y" false-label="N" v-model="v_pay" style=" margin-left:15px"><span style="font-size:12px;color:#f00">包含已付完</span>  </el-checkbox>
                </div>
                <el-table  :data="apData" 
                    border                            
                    disabled-hover
                    class="custom-table-border"
                    style="overflow:auto;margin-top:-8px;"
                    size="small"
                    header-cell-class-name="clearPadding"  
                    show-summary
                    :summary-method="getSummary"
                    :height="tabHeight" 
                    :row-key="getRowKey"  
                    :header-cell-style="{ 'color':'#f00','text-align':'center','height':'16px'}"
                    ref="refap" 
                    :cell-style="{padding:'2px','font-size':'12px',color:'#001','font-weight':'600'}"
                    v-loading="v_loading"
                    element-loading-text="加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    highlight-current-row>
                    <el-table-column label="序号" type="index" width="55" fixed align="center">
                        <el-table-column label="序号" type="index" width="55" fixed align="center">
                            <template slot="header"  >
                                <el-link   @click="apShow" style="font-size:12px;color:#404eff"> 
                                    <el-tooltip content=" 清除条件" effect="light">
                                        <i class="iconfont icon-shanchu1"  ></i>
                                    </el-tooltip>
                                </el-link>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column  v-for="(item,index ) in apCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.key!=='RN'&&item.sortable=='N'"
                        :min-width="item.width">
                        <el-table-column  resizable :prop="item.key" :label="item.title" :align="item.align"  show-overflow-tooltip :min-width="item.width">
                            <template slot="header" slot-scope="scope">
                                {{scope.row}}
                                <el-input type="number" placeholder="数字框"  @keyup.enter.native="getApList" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-if="item.edcss=='number'" size="mini" v-model="v_aprow[item.key]" style="width:100%"> </el-input> 
                                <el-input v-else @keyup.enter.native="getApList"  v-model="v_aprow[item.key]" size="mini" placeholder="请输入" ></el-input> 
                            </template>
                            <template slot-scope="scope" >
                                <el-checkbox v-if="item.edcss=='checkbox'"  true-label="Y"  false-label="N" v-model="scope.row[item.key]" ></el-checkbox>
                                <el-progress v-else-if="item.key=='PCT'" :text-inside="true" :stroke-width="22" :percentage="Number(scope.row['PCT'])"  color="red"></el-progress> 
                                <span v-else v-text="scope.row[item.key]"></span>
                            </template>
                        </el-table-column>
                    </el-table-column>                   
                </el-table>  
                <div class="one-div" style="margin-top:2px"> <span class="oneRow"> 当前资金预测 </span> 
                    <el-button   @click="exeTest" type="primary" plain size="mini" style="height:25px;margin-top:2px;margin-left:20px;border:1px solid #ff0000">
                        <i class="iconfont icon-baocun" style=" font-size:12px;margin-right:3px"></i>执行预测
                    </el-button>
                </div>
                <div style="background:#f7f8f9; height:225px;margin-top:-6px;overflow-y:auto;">
                    <div style="display:flex ;flex-wrap:wrap;gap:20px;margin-left:10px;width:350px">
                        <div style="width: 320px; height: 215px;background: #fcc;border-radius: 10px; margin-top:5px">
                            <div style="display:flex;margin-top:5px;border-bottom:1px dashed #fff;font-size:13px;font-weight:600;padding-left:12px;line-height:35px;">
                                <div style="color:#000;width:110px">预测月份：</div>
                                <div style="color:#409eff;width:100px">{{v_dttm}}</div>
                            </div>
                            <div style="display:flex;margin-top:5px;border-bottom:1px dashed #fff;font-size:13px;font-weight:600;padding-left:12px;line-height:35px;">
                                <div style="color:#000;width:110px">当前账户余额：</div>
                                <div style="color:#409eff;width:100px">{{v_money_format}}</div>
                            </div>
                            <div style="display:flex;margin-top:5px;border-bottom:1px dashed #fff;font-size:13px;font-weight:600;padding-left:12px;line-height:35px;">
                                <div style="color:#000;width:110px">应收金额：</div>
                                <div style="color:#409eff;width:100px">{{v_sumAr_format}}</div>
                            </div>
                            <div style="display:flex;margin-top:5px;border-bottom:1px dashed #fff;font-size:13px;font-weight:600;padding-left:12px;line-height:35px;">
                                <div style="color:#000;width:110px">应付金额：</div>
                                <div style="color:#f00;width:100px">{{v_sumAp_format}}</div>
                            </div>
                            <div style="display:flex;margin-top:5px;border-bottom:1px dashed #fff;font-size:13px;font-weight:600;padding-left:12px;line-height:35px;">
                                <div style="color:#000;width:110px">资金盈缺：</div>
                                <div style="color:green;width:100px">{{v_minus_format}}</div>
                                <el-tag size="small" v-if="v_minus>0"  type="success" style="margin-top:5px">盈 </el-tag>
                                <el-tag size="small" v-else-if="v_minus<0"  type="danger" style="margin-top:5px">缺 </el-tag>
                                <el-tag size="small" v-else  type="info" style="margin-top:5px">待预测</el-tag>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 提示框 -->
        <form-dialog @child-exit="handleConfirm" v-bind:v_win="promptWin" v-bind:message="prompt"></form-dialog>
    </div>  
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import {getDate,getCurrentMth} from '../../api/Select' 
import formDialog from '../datamgt/form_dialog.vue' 
//局部注册
export default {
    name:"asset_config",
    data () {
        return {
            v_row:{},
            v_dttm:'',
            v_receive:'N',
            saveFlag:false,
            promptWin:false,
            prompt:'',
            v_minus:0,
            v_minus_format:'',
            tabData:[], //表数据
            apData:[],
            tabArr:[], //表列
            minData:[],  
            apCol:[],
 
            t_loading:false,
            v_loading:false,
            minCol:[],
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_formurl:'xuper_auth/getFormGroup', 
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
            v_admin:this.$cookies.get('v_admin') ,//api 请求密码
            v_sumAr_format:'',
            v_sumAr:0,
            v_money:'',
            v_money_format:'',
            v_sumAp_format:'',
            v_sumAp:0,
            notNull:[],
            cashArr:[],
            v_aprow:{},
            stfgBool:true,
            addBool:false, //新增,为true时--禁止
            editBool:false, //编辑,为true时--禁止
            delBool:false, //删除 ,为true时--禁止
            cfmBool:false, //审核 ,为true时--禁止
            cancelBool:false, //作废 ,为true时--禁止
            v_pay:'N',
            pickerOptions: {
                disabledDate(time) {
                    const now = new Date();
                    const minDate = new Date(now.getFullYear(), now.getMonth(), 1);
                    const maxDate = new Date(now.getFullYear(), now.getMonth() + 12, 1);
                    return time < minDate || time >= maxDate;
                }
            }
        }
    },
    mounted () { 
        this.v_dttm =getCurrentMth() 
        //查询数据
        this.qryTabData()
 
        //用户表单新增、编辑、审核、作废权限  
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','471198','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })  
 
    },
    computed: {
 
        tabHeight: function() {
            return (window.innerHeight - 420) + 'px';
        }, 
    },
    components: {
        formDialog,
    },
    created () {       
        if (this.v_username){             
            this.getTabField() //表列字段
 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        //执行预测
        exeTest(){
            //1、应收
            this.v_sumAr=''
            this.tabData.filter(item=>item['SEL']=='N').forEach(item=>{
                this.v_sumAr =(Number(this.v_sumAr)+Number(item['NOAMT']||0)).toFixed(2)                
            })
            this.v_sumAr_format=Number(this.v_sumAr).toLocaleString('en-US')
            //2、应付
            this.v_sumAp=''
            this.apData.filter(item=>item['SEL']=='N').forEach(item=>{
                this.v_sumAp=(Number(this.v_sumAp)+Number(item['NOAMT']||0)).toFixed(2)                
            })
            // 3、盈 亏 
            this.v_minus=''
            this.v_sumAp_format=Number(this.v_sumAp).toLocaleString('en-US')
            this.v_minus =(Number(this.v_money)+Number(this.v_sumAr)-Number(this.v_sumAp)).toFixed(2)
            this.v_minus_format =Number(this.v_minus).toLocaleString('en-US')
        },
        rowShow(){  
            this.v_row ={}
            this.getArList()
        } ,
        apShow(){  
            this.v_aprow ={}
            this.getApList()
        } ,
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='AMT'||column.property==='ACTAMT'||column.property==='NOAMT' ){
                    sums[index]=Number(values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(1)
                        }else{
                            return prev
                        }
                    },'') ).toLocaleString('en-US')
                }
            })
            return sums
        },
        getMinSum(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='AMT'||column.property==='CURMONEY'  ){
                    sums[index]=Number(values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(1)
                        }else{
                            return Number(prev)
                        }
                    },'')).toLocaleString('en-US')
                }
            })
            //console.log(JSON.stringify(sums))
            return sums
        },
        handleConfirm(){
            this.promptWin=false
        },
        //应收明细
        getArList(){
            this.v_sumAr=0
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabArr.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_edcss =='number'){
                        v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                    }else{
                        v_cond =v_cond +' and  '+item+'  like \'%'+ (this.v_row[item]).trim()+'%\''
                    }

                }
            })
            let cond=' and mth <= \''+this.v_dttm +'\' and pct<99'   
            if (this.v_receive =='Y'){
                cond=' and mth <= \''+this.v_dttm +'\''  
            }
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'corpid', p_value:this.v_corpid,p_cond:v_cond + cond +' order by mth',p_table:'V_AR_LIST'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.tabData =res.result
                    
                    this.$nextTick(()=>{
                        this.$refs['refar'].doLayout()
                    })
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
            }) 
        },
 
        getRowKey(row){
            return row.IDSEQ
        },
        //应付明细
        getApList(){
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_aprow).forEach(item=>{
                if (this.v_aprow[item] ){
                    this.apCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_edcss =='number'){
                        v_cond =v_cond +' and '+item+'>='+  this.v_aprow[item] 
                    }else{
                        v_cond =v_cond +' and  '+item+'  like \'%'+ (this.v_aprow[item]).trim()+'%\''
                    }

                }
            })
            let cond=' and mth <= \''+this.v_dttm +'\' and pct<99'  
            if (this.v_pay =='Y'){
                cond=' and mth <= \''+this.v_dttm +'\''  
            }
            this.v_loading =true
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'corpid', p_value:this.v_corpid,p_cond:v_cond + cond +' order by mth',p_table:'V_AP_LIST'},
            }).then(res=>{ 
                if (res.code==='200'){
                    this.apData =res.result
                    this.$nextTick(()=>{
                        this.$refs['refap'].doLayout()
                        this.v_loading =false
                    })
                }else{
                    this.promptWin=true
                    this.prompt=res.result
                }
            }) 
        },
        //查询
        qryTabData(){
            if (this.v_dttm){
                this.getArList() //应收
                this.getApList() //应付
                this.getCashList()
                // 汇总应收、应付、账户 余额
                let v_sumcash=''
                 
            }else{
                this.promptWin =true
                this.prompt ='账单月份不能为空'
            }
        },
        getCashList(){
            this.v_money =0
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key:'corpid', p_value:this.v_corpid, p_table:'V_BANK_LOG_GP'},
            }).then(res=>{ 
                let v_maxdttm =res.result[0]['DTTM']
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: { p_key:'corpid', p_value:this.v_corpid,p_cond: ' and stfg=\'Y\' order by sortby',p_table:'v_account'},
                }).then(res=>{ 
                    this.cashArr =res.result
                    this.cashArr.forEach(item=>{
                        item['CHKDTTM']=v_maxdttm
                        this.v_money=(Number(this.v_money)+Number(item['CURMONEY']||0)).toFixed(2)                        
                    })
                    this.v_money_format=Number(this.v_money).toLocaleString('en-US')
                    this.$nextTick(()=>{
                        this.$refs['refmin'].doLayout()
                    })
                })
            })
        },
 
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','471198','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','471198','lstseq','2','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.apCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','471198','lstseq','3','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.minCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
 
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }  
 
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .active { 
        color:#D200D2; 
    } 
 
</style>
<style lang="less">
    /* 全局样式文件 */
    .el-range-separator {
        width: 26px !important;  /* 调整至合适宽度 */
    }

    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 